// React
import React, {
  useState,
  useEffect,
  useContext,
  useMemo,
  useCallback,
} from "react";
// React
// CSS
import styles from "./TeachItemVideoShower.module.css";
import "./videoConfig.css";
// CSS
// Services
// Services
// Contexts
import { UserTokenContext } from "../../Contexts/userToken";
// Contexts
// Modules
import { useNavigate, useParams } from "react-router-dom";
// Modules
// Models
import {
  I_QuizMakerQuestions,
  I_TechItemPart,
  _Option,
} from "../../Models/interfaces";
// Models
// Components
import Swal from "sweetalert2";
import Comments from "./Comments/Comments";
import ModalForPartSelecting from "./ModalForPartSelecting/ModalForPartSelecting";
// Components
// Utils
import { FiMonitor } from "react-icons/fi";
import Quiz from "./Quiz/Quiz";
import Modal from "./Modal/Modal";
import PlaybackModal from "./PlaybackModal/PlaybackModal";
import AddCommentsModal from "./Comments/AddCommentsModal/AddCommentsModal";
import { _parser } from "../../Utils/_parser";
import { _stringify } from "../../Utils/_stringify";
import {
  AllDataNeededContext,
  SetAllDataNeededContext,
} from "../../Contexts/AllDataNeededContext";

import { getPartsOfTeachItemWithIdService } from "../../Services/parts/get/getPartsOfTeachItemWithIdService";
import { getUserProfile_Service } from "../../Services/Profile/get/getUserProfile_Service";
import PendingAndErrorManager from "../../Components/PendingAndErrorManager/PendingAndErrorManager";
import VideoPlayer from "./VideoPlayer/VideoPlayer";
import { IoIosArrowDown } from "react-icons/io";
import { isIOS } from "../../Utils/is_IOS";
// Icons

type TeachItemVideoShowerProps = {
  setIsNeedFullScreen: React.Dispatch<React.SetStateAction<boolean>>;
  setUserQuestions: React.Dispatch<
    React.SetStateAction<I_QuizMakerQuestions[]>
  >;
};

export const PlaySpeedContext = React.createContext(100);
export const SetPlaySpeedContext = React.createContext<
  React.Dispatch<React.SetStateAction<number>>
>(() => {});

const TeachItemVideoShower: React.FunctionComponent<
  TeachItemVideoShowerProps
> = ({ setIsNeedFullScreen }) => {
  // States
  const [userNumber, setUserNumber] = useState<string>("");
  const [teachData, setTeachData] = useState<I_TechItemPart>({
    data: [],
    data_count: 0,
    has_paid: false,
    lesson_id: 0,
    lesson_name: "",
    quiz: {
      award: 0,
      early_price: 0,
      gift_price: 0,
      grade_name: "",
      has_paid: false,
      id: 1,
      is_locked: false,
      price: 0,
      questions: [],
      Quiz_date: "",
      quiz_time: 1,
      shamsi_quiz_date: "",
      title: "",
      answer_file: "",
      grade_id: 1,
    },
    section_name: "",
    subject_name: "",
    subject_id: 0,
    teacher_id: 0,
    teacher_name: "",
  });
  const [currMode, setCurrMode] = useState<"quiz" | "media">("media");
  const [currDataIndex, setCurrDataIndex] = useState<number>(0);
  const [isPending, setIsPending] = useState<boolean>(true);
  const [isPlayBackSpeedModalInScreen, setIsPlayBackSpeedModalInScreen] =
    useState<boolean>(false);
  const [questionAnswer, setQuestionAnswer] = useState<_Option>({
    id: 0,
    image_url: "",
    is_correct: false,
    title: "",
  });
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isBuyQuizModalInScreen, setIsBuyQuizModalInScreen] =
    useState<boolean>(false);
  const [isCommentModalOpen, setIsCommentModalOpen] = useState<boolean>(false);

  const allDataNeeded = useContext(AllDataNeededContext);

  const setAllNeededData = useContext(SetAllDataNeededContext);

  const [playSpeed, setPlaySpeed] = useState<number>(100);

  // States
  /******************************************************** */
  /******************************************************** */
  /******************************************************** */
  /******************************************************** */
  /******************************************************** */
  // Constants
  const userToken = useContext(UserTokenContext);
  const { teachItemId } = useParams();
  const navigate = useNavigate();
  //
  function createMarkup(markup: string) {
    return { __html: markup };
  }
  //
  // Constants
  /******************************************************** */
  /******************************************************** */
  /******************************************************** */
  const handleChangeSectionForOneTimeLink: () => void = useCallback(() => {
    setIsPending(true);
    getPartsOfTeachItemWithIdService(userToken, String(teachItemId))
        .then(({ data }) => {
          // Update LocalStorage For better UX and Handling refresh
          setTeachData(data);
          setAllNeededData((prevState) => ({
            ...prevState,
            teacherId: data.teacher_id,
            teacherName: data.teacher_name,
            subjectId: data.subject_id,
            lessonId: data.lesson_id,
            lessonName: data.lesson_name,
            sectionName: data.subject_name,
          }));
          setTeachData(data);

          if (data.data[currDataIndex].is_video === true) {
            setCurrMode("media");
          } else {
            setCurrMode("quiz");
          }
          setIsPending(false);
        })
        .catch((err) => {
          setIsPending(false);
          console.log(err);
          Swal.fire({ icon: "error", title: err.response.data.message });
          navigate("/");
        });
  }, [userToken, teachItemId, setAllNeededData]);
  /******************************************************** */
  /******************************************************** */
  //
  const quiz = useMemo(
    () => (
      <Quiz
        createMarkup={createMarkup}
        currDataIndex={currDataIndex}
        questionAnswer={questionAnswer}
        setCurrDataIndex={setCurrDataIndex}
        setQuestionAnswer={setQuestionAnswer}
        teachData={teachData}
        onVideoSelected={handleChangeSectionForOneTimeLink}
      />
    ),
    [
      currDataIndex,
      teachData,
      questionAnswer,
      handleChangeSectionForOneTimeLink,
    ]
  );
  const media = useMemo(
    () => (
      <>
        <VideoPlayer
          currDataIndex={currDataIndex}
          teachData={teachData}
          onVideoSelected={handleChangeSectionForOneTimeLink}
          setCurrDataIndex={setCurrDataIndex}
          userNumber={userNumber}
          videoUrl={String(
            teachData?.data[currDataIndex]?.video_url || ""
          ).replace(/(http[^\s])/i, "https:").replace("::", ":")}
          extraChild={
            <>
              <button
                className={`${styles.buttonForChangeSection} absolute !-bottom-4
              left-4 px-2 text-white text-xs flex flex-row items-center ${
                isModalOpen ? "z-0" : "z-10"
              } ${currMode === "quiz" ? "-bottom-8" : styles.bottomManager}`}
                onClick={() => {
                  setIsModalOpen(true);
                }}
              >
                قسمت {currDataIndex + 1} از {teachData?.data.length}
                <IoIosArrowDown className="ml-2" />
              </button>
              {!isIOS() && (
                <button
                  className={`${
                    styles.buttonForChangeSection
                  } absolute  right-4 px-2 text-white text-xs flex flex-row items-center  ${
                    isModalOpen ? "z-0" : "z-10"
                  } `}
                  onClick={() => {
                    setIsPlayBackSpeedModalInScreen(true);
                  }}
                >
                  <span>
                    <span className="mr-1">{playSpeed / 100}x</span>
                    <span>سرعت پخش</span>
                  </span>
                  <IoIosArrowDown className="ml-2" />
                </button>
              )}
            </>
          }
        />
      </>
    ),
    [userNumber, teachData, currDataIndex, currMode, isModalOpen, playSpeed]
  );
  //
  /******************************************************** */
  /******************************************************** */
  /******************************************************** */
  /******************************************************** */
  /******************************************************** */
  //   LfeCycles
  //
  // profile data
  useEffect(() => {
    getUserProfile_Service(userToken)
      .then(
        ({
          data: {
            data: { phone },
          },
        }) => {
          setUserNumber(phone);
        }
      )
      .catch((err) => {
        console.log(err);
      });
  }, [userToken]);
  // profile data
  //

  //
  // part data
  useEffect(() => {
    getPartsOfTeachItemWithIdService(userToken, String(teachItemId))
      .then(({ data }) => {
        // Update LocalStorage For better UX and Handling refresh
        setTeachData(data);
        setAllNeededData((prevState) => ({
          ...prevState,
          teacherId: data.teacher_id,
          teacherName: data.teacher_name,
          subjectId: data.subject_id,
          lessonId: data.lesson_id,
          lessonName: data.lesson_name,
          sectionName: data.subject_name,
        }));
        setTeachData(data);

        if (data.data[0].is_video === true) {
          setCurrMode("media");
        } else {
          setCurrMode("quiz");
        }
        setIsPending(false);
      })
      .catch((err) => {
        console.log(err);
        setIsPending(false);
        Swal.fire({ icon: "error", title: err.response.data.message });
        navigate("/");
      });
  }, [userToken, teachItemId, navigate, setAllNeededData]);
  // part data
  //

  //
  // part selector
  useEffect(() => {
    if (teachData?.data.length === 0) return;
    teachData?.data[currDataIndex].is_video === true &&
    String(teachData?.data[currDataIndex].video_url).length > 8
      ? setCurrMode("media")
      : setCurrMode("quiz");
  }, [currDataIndex, teachData, setCurrMode]);
  // part selector
  //

  //
  // question reset
  useEffect(() => {
    setQuestionAnswer({
      id: 0,
      image_url: "",
      is_correct: false,
      title: "",
    });
  }, [currDataIndex]);
  //
  // question reset

  //
  // ls updater
  useEffect(() => {
    if (allDataNeeded.sectionName === "") return;
    const subject_name_str = _stringify(allDataNeeded?.sectionName || "");
    const lesson_name_str = _stringify(allDataNeeded?.lessonName || "");
    const lesson_id_str = _stringify(allDataNeeded?.lessonId || "");
    const teacher_name_str = _stringify(allDataNeeded?.teacherName || "");
    const teacher_id_str = _stringify(allDataNeeded?.teacherId || "");
    const subject_id_str = _stringify(allDataNeeded?.subjectId || "");
    localStorage.setItem(
      "selectedSubject",
      _stringify({
        id: subject_id_str,
        title: subject_name_str,
      })
    );
    localStorage.setItem("lessonId", lesson_id_str);
    const topImageUrl: any = String(
      _parser(
        localStorage.getItem("lessonData")
          ? localStorage.getItem("lessonData")
          : JSON.stringify("none")
      )
    );
    localStorage.setItem(
      "lessonData",
      _stringify({
        id: _parser(lesson_id_str),
        title: _parser(lesson_name_str),
        url: _parser(
          Boolean(topImageUrl.url) ? topImageUrl.url : JSON.stringify("none")
        ),
      })
    );

    localStorage.setItem("teacherId", teacher_id_str);
    localStorage.setItem("teacherName", teacher_name_str);

    // Update LocalStorage For better UX and Handling refresh
  }, [allDataNeeded]);
  // ls updater
  //

  /******************************************************** */
  /******************************************************** */
  /******************************************************** */
  /******************************************************** */
  /******************************************************** */
  return (
    <>
      <div
        className={`${styles.teachItemMasterContainer} w-screen h-screen overflow-y-hidden relative flex flex-col  justify-start dark:!text-black`}
      >
        <PendingAndErrorManager
          isDone={!isPending}
          isError={false}
          isPending={isPending}
          onError={() => {}}
          showAfterDone={
            <>
              <PlaySpeedContext.Provider value={playSpeed}>
                <SetPlaySpeedContext.Provider value={setPlaySpeed}>
                  {currMode === "quiz" ? quiz : media}
                </SetPlaySpeedContext.Provider>
              </PlaySpeedContext.Provider>
              <div
                className={`${styles.mainContent} h-[150px] p-6 pb-0 flex flex-col items-end`}
              >
                <p className="flex flex-row-reverse items-center justify-start">
                  <FiMonitor />
                  <span className="mr-2 text-base">
                    {teachData?.section_name}
                  </span>
                </p>
                <p className="flex flex-row-reverse text-xs mt-2 text-gray-700">
                  <span>{teachData?.lesson_name}</span>
                  {" - "}
                  <span>{teachData?.subject_name}</span>
                </p>
                <p className="text-xs mt-1 text-gray-700">
                  <span>مدرس :</span>
                  <span>{allDataNeeded.teacherName}</span>
                </p>

                <div className="w-full flex items-center justify-between mt-4">
                  <button
                    className={`text-xs transition-all py-2 px-4 rounded-lg text-white ${
                      isModalOpen ? "z-0" : "z-10"
                    } ${styles.midBtn}`}
                    style={{ background: "rgb(76 , 175 ,80)" }}
                    onClick={() => {
                      setIsBuyQuizModalInScreen(true);
                    }}
                  >
                    آزمون پایانی این بخش
                  </button>
                  <button
                    className={`text-xs transition-all py-2 px-4 rounded-lg text-white ${
                      isModalOpen ? "z-0" : "z-10"
                    } ${styles.midBtn}`}
                    style={{ background: "blueviolet" }}
                    onClick={() => {
                      navigate(-1);
                    }}
                  >
                    بازگشت
                  </button>
                </div>
              </div>
              {isModalOpen ? (
                <ModalForPartSelecting
                  data={teachData ? teachData?.data : []}
                  setIsModalOpen={setIsModalOpen}
                  setCurrMode={setCurrMode}
                  setCurrDataIndex={setCurrDataIndex}
                  onVideoClick={handleChangeSectionForOneTimeLink}
                />
              ) : null}

              {isPlayBackSpeedModalInScreen ? (
                <PlaybackModal
                  setIsPlayBackSpeedModalInScreen={
                    setIsPlayBackSpeedModalInScreen
                  }
                  setPlayBackSpeed={(data) => {
                    setPlaySpeed(data);
                  }}
                />
              ) : null}
              {/* PartSelectorModal */}
              {/*  */}
              {/*  */}
              {/* QuizShopModal */}
              {isBuyQuizModalInScreen === true ? (
                <>
                  <Modal
                    setIsBuyQuizModalInScreen={setIsBuyQuizModalInScreen}
                    quizData={teachData?.quiz}
                    lessonName={""}
                    subjectName={teachData?.section_name ?? ""}
                  />
                </>
              ) : null}
              {isCommentModalOpen ? (
                <AddCommentsModal
                  setIsModalInScreen={setIsCommentModalOpen}
                  _lessonData={String(
                    `${teachData?.lesson_name} ${teachData?.subject_name}`
                  )}
                  teacherName={
                    String(_parser(localStorage.getItem("teacherName"))) ||
                    allDataNeeded.teacherName
                  }
                  sectionId={String(teachItemId)}
                />
              ) : null}
              <Comments
                isModalOpen={isModalOpen}
                setIsCommentModalOpen={setIsCommentModalOpen}
              />
            </>
          }
        />
      </div>
    </>
  );
};

export default TeachItemVideoShower;
